import React, { Fragment, useState, useCallback, useMemo, useEffect } from 'react';
//import { Calendar, Views, dateFnsLocalizer, } from 'react-big-calendar'
import PropTypes from 'prop-types'
//import "react-big-calendar/lib/css/react-big-calendar.css";
//import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { format, parse, startOfWeek, getDay } from "date-fns";
import { functions } from 'constantes';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { Typography } from '@mui/material';
import { useStyles } from './estilos';
import FormularioParaAsignacion from './FormularioParaAsignacion';
import DetalleCoberturaAsignada from './DetalleCoberturaAsignada';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { useDispatch } from 'react-redux';
import { obtenerRegistrosPersonalizado, patchPersonalizadoConDosMetodos } from 'store/actions/customAction';
import dayjs from 'dayjs';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { catalogoDeCandidaturasEleccion } from 'constantes/globalsStates';
var isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)

const lang = {
  es: {
		date: "Fecha",
		time: "Tiempo",
		event: "Evento",
		allDay: "Todo el día",
    week: "Semana",
    work_week: "Semana de trabajo",
    day: "Día",
    month: "Mes",
    previous: "Atrás",
    next: "Después",
		today: "Hoy",
		yesterday: "Ayer",
		tomorrow: "Mañana",
    agenda: "Agenda",
    sunday: "Domingo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miercoles",
    thursday: "Jueves",
    friday: "viernes",
		saturday: "sabado",
    showMore: (total) => `+${total} más`
  },
}

let respuestaMap = []
let respuestaDisponibilidades = []
let respuestaEventos2 = []
let defaultGlobalDate = new Date()
let datosDelMedioContratadoGlobal = {}
const CalendarioElaboracionPlanDeMedios = ({ title, openFullScreenDialog, handleClose, datosDelMedio, dayLayoutAlgorithm = 'no-overlap', }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [registrosDePlanDeMedios] = useState("registrosDePlanDeMedios");
  const [gestionarDeEspaciosDeMedios] = useState("gestionarDeEspaciosDeMedios");
  const [abrirFormularioAsignacion, setabrirFormularioAsignacion] = useState(false);
  const [abrirDetalleDeCobertura, setAbrirDetalleDeCobertura] = useState(false);
  const [datosDelEspacioContratado, setDatosDelMedioContratado] = useState({});
  const [myEvents, setEvents] = useState([])
  //const localizer = dateFnsLocalizer({ format, parse, startOfWeek, getDay, locales: lang['es']})
  const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const {nivelCobertura, nombreMedio, tipoCandidatura} = datosDelMedio;
  useEffect(() => {
    obtenerDisponibilidadesDelMedio()
  }, [])

  useEffect(() => {
    obtenerEspaciosDeMedios()
  }, [])

  const obtenerDisponibilidadesDelMedio = async () => {
    setcargandoSolicitud(true);
    respuestaMap = []
    respuestaDisponibilidades = []
    respuestaEventos2 = []
    setEvents([])
    ServiciosDelAPI[registrosDePlanDeMedios].metodoDeBusqueda.clear();
    ServiciosDelAPI[registrosDePlanDeMedios].metodoDeOrden.clear();
    ServiciosDelAPI[registrosDePlanDeMedios].metodoDeOrden.addDesc("fechaInicio");

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: registrosDePlanDeMedios,
        saveInStore: false,
        nombreDelMetodo: `listar/disponibilidades/${datosDelMedio?.idMedioDeComunicacion || ""}` ,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });

    if(respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: "No se encontraron disponibilidades de este medio de comunicación", mostrarRespuesta: true, });

    const respuestaDataMap = respuesta?.data?.map(({id, fechaInicio, fechaFin, cantidadDisponiblePorDia, espacioPresidente, espacioDiputado, espacioAlcalde, paginasPorPartido, medio_de_comunicacion_id}) => ({id: `${id}_${id}`, start: new Date(fechaInicio), end: new Date(functions.formatearFechaYYYY_MM_DD(fechaFin)), cantidadDisponiblePorDia, espacioPresidente, espacioDiputado, espacioAlcalde, paginasPorPartido, medio_de_comunicacion_id}) )
    setEvents(respuestaDataMap)
    defaultGlobalDate = respuesta?.data[0]?.fechaInicio;
    respuestaDisponibilidades = respuesta.data;
  }

  const obtenerValorAsignado = (disponibilidadEncontrada) => {
    switch (datosDelMedio.idEleccion) {
        case catalogoDeCandidaturasEleccion.PRESIDENTE:     // 1 = presidente
            return disponibilidadEncontrada?.espacioPresidente
        case catalogoDeCandidaturasEleccion.CORPORACIONES: // 2 = coporracoines municipal
          return disponibilidadEncontrada?.espacioAlcalde
        case catalogoDeCandidaturasEleccion.DIPUTACIONES: // 3 = dioutaciones
          return disponibilidadEncontrada?.espacioDiputado
        default:
            return  ""
    }
  };

  const obtenerEspaciosDeMedios = async () => {
    respuestaEventos2 = []

    setcargandoSolicitud(true);

    ServiciosDelAPI[gestionarDeEspaciosDeMedios].metodoDeBusqueda.clear();

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
        controller: gestionarDeEspaciosDeMedios,
        saveInStore: false,
        nombreDelMetodo: `listar/registros/${datosDelMedio?.idEleccion || ""}/${datosDelMedio?.nivelCobertura?.id || ""}/${datosDelMedio?.idMedioDeComunicacion || ""}`
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No se encontraron espacios de medios", mostrarRespuesta: true, });

    if(respuesta?.data?.length === 0) return;

    respuestaMap = respuesta?.data?.map( ({id, fechaDeAsignacion, idDisponibilidad, cantidadAsignada, id_org_pol, tipo_eleccion_id, medio_de_comunicacion_id}) => {
      const disponibilidadEncontrada = validarFechaEnRango(fechaDeAsignacion)

      if(disponibilidadEncontrada?.length > 0) {
        return {id, start: new Date(functions.cambiarFormatoFecha(fechaDeAsignacion)), end: new Date(functions.formatearFechaYYYY_MM_DD(fechaDeAsignacion)), medio_de_comunicacion_id, title: `${cantidadAsignada} / ${obtenerValorAsignado(disponibilidadEncontrada[0])} `, idDisponibilidad, id_org_pol, tipo_eleccion_id}
      }
      return {id, start: new Date(functions.cambiarFormatoFecha(fechaDeAsignacion)), end: new Date(functions.formatearFechaYYYY_MM_DD(fechaDeAsignacion)), medio_de_comunicacion_id, title: `${cantidadAsignada}`, idDisponibilidad, id_org_pol, tipo_eleccion_id}
    })

    setEvents((state)=> [...state, ...respuestaMap])
    datosDelMedio.disponibilidadEncontrada = [];
    respuestaEventos2= respuestaMap;
  }

  // Para mostrar formulario para ingresar envento
  const handleSelectSlot = useCallback( (slotInfo, ) => {
      const { start, end } = slotInfo;
      // console.log("slotInfo", slotInfo)

      const disponibilidadEncontrada = validarFechaEnRango(start)

      if(disponibilidadEncontrada?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: `No hay disponibilidad para esta fecha ${functions.FormatearFechaLarga(start)}`, mostrarRespuesta: true, });

      const elementoRespuesta3 = respuestaEventos2?.find( (elemento) => new Date(start) >= new Date(elemento.start) && new Date(start) <= new Date(elemento.start))

      if(elementoRespuesta3?.id) {
        const existeEvento = respuestaDisponibilidades.some( (elemento) => elemento.id === elementoRespuesta3.id)
        if(!existeEvento) return setDatosDeRespuesta({ tipoDeAlerta: 'warning', mensajeDeAlerta: `Ya asignó ${elementoRespuesta3?.title} para esta fecha ${functions.FormatearFechaLarga(start)}`, mostrarRespuesta: true, });
      }

      datosDelMedio.diaContratar = start;
      datosDelMedio.diaFinal = end;
      datosDelMedio.cantidadEditar = "";
      datosDelMedio.idRegistro = null;
      datosDelMedio.disponibilidadEncontrada = disponibilidadEncontrada;
      setabrirFormularioAsignacion(true);
    },
    [setabrirFormularioAsignacion]
  )


  const validarFechaEnRango = (start) => respuestaDisponibilidades.filter( ({fechaInicio, fechaFin}) => new Date(start) >= new Date(fechaInicio) && new Date(start) <= new Date(fechaFin))

  const manejadorAgregarAsignacion = useCallback( (dataForm, datosDelMedio, respuesta, idRegistro) => {
    const {cantidadAsginar} = dataForm;

    if(idRegistro) {
      setEvents((prev) => prev.map( (item) => item.id === idRegistro ? {...item, title: `${cantidadAsginar} / ${item?.title?.split("/").length > 0 ? item?.title?.split("/")[1] : "" }`} : item ))
      setDatosDelMedioContratado({...datosDelMedioContratadoGlobal, title: `${cantidadAsginar} espacios(s)` })
      setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data?.data || "ESPACIOS EDITADOS CORRECTAMENTE", mostrarRespuesta: true, });
      setabrirFormularioAsignacion(false);
      setAbrirDetalleDeCobertura(false);
      setTimeout(() => {
      setAbrirDetalleDeCobertura(true);
      }, 2000);
      return;
    }
    setabrirFormularioAsignacion(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data?.data || "ESPACIOS ASIGNADOS CORRECTAMENTE", mostrarRespuesta: true, });

    setEvents( (prevState) => prevState.filter(item => !item.title));
    obtenerEspaciosDeMedios()
    }, []
  )

  // Para mostrar la información cuando seleccionan un evento
  const handleSelectEvent = useCallback( (event) => {
      if(!event?.title) return;
      // console.log("datos", event)
      setDatosDelMedioContratado({...event, datosDelMedio})
      setAbrirDetalleDeCobertura(true);
      setabrirFormularioAsignacion(false);
  }, [])

  const { defaultDate, scrollToTime, messages } = useMemo(
  () => ({
    defaultDate: new Date(defaultGlobalDate) || new Date(),
    scrollToTime: new Date(defaultGlobalDate) || new Date("2022-9-01T06:00:00.000+0000"),
    messages: lang['es'],
  }),
  [defaultGlobalDate])

  const slotGroupPropGetter = useCallback( (data) => {
      return {
        style: {  minHeight: 10, },
      }
  }, [])
    //EVENT STYLE GETTER FOR SLYLING AN EVENT ITEM
  const eventStyleGetter = (event, start, end, isSelected) => {
    // console.log("eventStyleGetter", event, start, end, isSelected);
    return {
      style: {
        backgroundColor: event?.title ? "#1976d2" : "#5fa6ec",
        height: event?.title ? '24px' : '5px',
        fontSize: '16px'
      }
    };
  }

  const cerrarFormularioAsignacion= () => { setabrirFormularioAsignacion(false) };
  const cerrarDetalleDeCobertura= () => { setAbrirDetalleDeCobertura(false) };

  const manejadorEliminarAsignacion= async (espacioContratado) => {
    setcargandoSolicitud(true);
    setAbrirDetalleDeCobertura(false)
    const data = { controller: gestionarDeEspaciosDeMedios, action: 'eliminar', data: {}, method: `${espacioContratado?.id}`, methodTwo: "", tipoMetodo: "DELETE" };
    const respuesta = await dispatch(patchPersonalizadoConDosMetodos(data));
    setcargandoSolicitud(false);

    if(respuesta?.error) {
      setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "No se pudó eliminar lo(s) espacio(s)", mostrarRespuesta: true });
      setTimeout(() => {
        setAbrirDetalleDeCobertura(true)
      }, 3000);
      return
    }

    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data || "Registro eliminado correctamente", mostrarRespuesta: true });
    setEvents( (prevState) => prevState.filter(item => !item.title));
    obtenerEspaciosDeMedios()
  };

  const manejadorEdicionAsignacion= (espacioContratado) => {
  const {start, title, id} = espacioContratado;
    datosDelMedio.diaContratar = start;
    datosDelMedio.diaFinal = start;
    datosDelMedio.cantidadEditar = title?.split(" ")[0];
    datosDelMedio.idRegistro = id;
    datosDelMedioContratadoGlobal = espacioContratado;
    setabrirFormularioAsignacion(true);
  };

  const handClose = (_, reason) => {
    if (reason === 'clickaway') {return}
    setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: "", mostrarRespuesta: false, });
  };

  const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

  return (
    <DialogoPantallaCompleta
      openFullScreenDialog={openFullScreenDialog}
      handleClose={handleClose}
      title={title}
      fullscreen={true}
      showIconButton={true}
      showButtonClose={false}
    >
      <Fragment>
          {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
          <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>
          <Typography className={classes.titulo}> {tipoCandidatura || ""} - {nombreMedio || ""} - ({nivelCobertura?.name || ""}) </Typography>
          <Typography className={classes.subtituloFormulario}> Medio de comunicación: {datosDelMedio?.nombreMedioDeComunicacion} </Typography>
          <div className="height600" style={{marginTop: 20, paddingBottom: 30}}>
            {/* <Calendar
              culture={'es'}
              dayLayoutAlgorithm={"overlap"}
              defaultDate={defaultDate}
              // resizable
              defaultView={Views.MONTH}
              events={myEvents}
              localizer={localizer}
              messages={messages}
              selectable
              views={["month", "week", "day",]}
              style={{ height: 670 }}
              scrollToTime={scrollToTime}
              popup
              onShowMore={(events, date) => console.log("onShowMore", { events, date })}
              eventPropGetter={eventStyleGetter}
              onSelectEvent={handleSelectEvent}
              onSelectSlot={handleSelectSlot}
              slotGroupPropGetter={slotGroupPropGetter}
              // backgroundEvents={backgroundEvents}
              showAllEvents
              showMultiDayTimes={true}
              // toolbar={false}
              step={160}
            /> */}
          </div>
          {abrirFormularioAsignacion && (
            <FormularioParaAsignacion
                openFullScreenDialog={abrirFormularioAsignacion}
                handleClose={cerrarFormularioAsignacion}
                title={""}
                datosDelMedio={datosDelMedio}
                manejadorAgregarAsignacion={manejadorAgregarAsignacion}
            />
          )}
          {abrirDetalleDeCobertura && (
            <DetalleCoberturaAsignada
                openFullScreenDialog={abrirDetalleDeCobertura}
                handleClose={cerrarDetalleDeCobertura}
                titleDialog={"DETALLE DE ESPACIO PUBLICITARIO CONTRATADO"}
                datosDelEspacioContratado={datosDelEspacioContratado}
                manejadorEliminarAsignacion={manejadorEliminarAsignacion}
                manejadorEdicionAsignacion={manejadorEdicionAsignacion}
            />
          )}
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

CalendarioElaboracionPlanDeMedios.propTypes = {
  // localizer: PropTypes.instanceOf(DateLocalizer),
  dayLayoutAlgorithm: PropTypes.string,
}

export default CalendarioElaboracionPlanDeMedios;